export default __webpack_public_path__ + "static/media/lioness_pride.690959e2.webp";